export default "__VITE_ASSET__CJl2b8K5__"